import { Button as MUIButton } from "@mui/material";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { getSlotState } from "app/reducers/slotsSlice";
import { fetchSlots } from "app/thunks/slotsAPI";
import classNames from "classnames";
import { NAVIGATOR } from "features/navigation";
import { useEffect } from "react";
import { useHistory } from "react-router";
import { Spinner, Title } from "ui";
import { BUTTON_STYLES, BUTTON_TYPES } from "ui/Button";

export const HomeScreen = () => {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const { slots, isFetching } = useAppSelector(getSlotState);

  useEffect(() => {
    dispatch(fetchSlots());
  }, [dispatch]);

  const areSlotsLinked = slots.some((slot) => slot.deviceId !== null);

  const handleNavigation = () => {
    areSlotsLinked
      ? history.push(NAVIGATOR.sessions)
      : history.push(NAVIGATOR.link);
  };

  if (isFetching) {
    return (
      <div className="flex w-full justify-center items-center bg-faux-dark-gunmetal h-screen">
        <Spinner size={60} />
      </div>
    );
  }

  return (
    <div className="flex-col w-full min-h-screen px-8 pt-16 pb-8 justify bg-faux-dark-gunmetal">
      <Title text="Nueva partida" />
      <div className="flex flex-col items-center justify-center align-center w-full mt-16">
        <Title
          className="mb-10 text-white"
          text={areSlotsLinked ? "¡Todo listo para comenzar!" : "¡Hola!"}
        />
        <p className="flex text-center">
          {areSlotsLinked
            ? "Haz click en Ver Sesiones para comenzar la siguiente partida."
            : "Para poder comenzar a operar y generar una nueva sesión de juego es necesario que se completen los seteos iniciales. Haz click en el botón Iniciar Seteo para comenzar. "}
        </p>
        <MUIButton
          variant="contained"
          disabled={false}
          onClick={handleNavigation}
          className={classNames(BUTTON_STYLES[BUTTON_TYPES.HOME])}
        >
          {areSlotsLinked ? "Ver sesiones" : "Iniciar seteo"}
        </MUIButton>
      </div>
    </div>
  );
};
